<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  @if (dialogMode === 'edit' || dialogMode === 'verify') {
    <div class="col-12">
      <form class="row" (ngSubmit)="onSubmit(f)" #f="ngForm">
        @if (dialogMode === 'edit') {
          <div class="col-12 col-sm-6">
            <div
              class="input-group-material Xinput-group-material--centered pb-2 margin-top-15"
              [class.input-group-material--error]="fsaAmountInputVar.invalid && fsaAmountInputVar.touched"
            >
              <web-components-number-input
                id="fsaAmount"
                [(ngModel)]="editData[ATTR_NEW_FSA_AMOUT]"
                name="fsaAmount"
                [zeroPositiveAndInputLowerThan]="1000"
                [minimumValue]="fsaMinValue(editData[ATTR_NEW_FSA_VALIDFROM])"
                required
                [label]="'user-self-service.tax.change-fsa.label-amount' | transloco"
                #fsaAmountInputVar="ngModel"
                (input)="inputValueChanged()"
              />
              @if (fsaAmountInputVar.valid || fsaAmountInputVar.hasError('required')) {
                <div class="input-group-material-message">&nbsp;</div>
              }
              @if (fsaAmountInputVar.hasError('inputLowerThan')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-fsa.hint-amount-max' | transloco }}
                </div>
              }
              @if (fsaAmountInputVar.hasError('minimumValue')) {
                <div class="input-group-material-message">
                  {{
                    'user-self-service.tax.change-fsa.hint-amount-min-max-custom'
                      | transloco: { minAmount: existingFsaUsedAmount | currency: 'EUR' : 'symbol' }
                  }}
                </div>
              }
              @if (fsaAmountInputVar.hasError('positiveNonNull')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-fsa.hint-amount-min-max' | transloco }}
                </div>
              }
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 col-sm-6">
            <div
              class="input-group-material margin-top-15"
              [class.input-group-material--error]="fsavalidfromInputVar.invalid && fsavalidfromInputVar.touched"
            >
              <input
                type="text"
                required
                [(ngModel)]="editData[ATTR_NEW_FSA_VALIDFROM]"
                name="fsavalidfromyear"
                id="fsavalidfromyear"
                #fsavalidfromInputVar="ngModel"
                [class.empty]="!fsavalidfromInputVar.value"
                pattern="\d{4}"
                formValidatorsYearInputValidator
                [minYear]="validFromMinYear"
                [maxYear]="validFromMaxYear"
                (input)="inputValueChanged()"
              />
              <span class="input-group-material-icon-state"></span>
              <label for="fsavalidfromyear" [innerHTML]="'user-self-service.tax.change-fsa.valid-from' | transloco"> - </label>
              @if (fsavalidfromInputVar.valid || fsavalidfromInputVar.hasError('required')) {
                <div class="input-group-material-message">&nbsp;</div>
              }
              @if (fsavalidfromInputVar.hasError('minYear') || fsavalidfromInputVar.hasError('maxYear')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-fsa.label-valid-from' | transloco: { minYear: validFromMinYear } }}
                </div>
              }
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 Xmb-3">
            <div class="custom-control custom-checkbox margin-bottom-15 Xmargin-top-15">
              <input
                #checkValidToInputVar="ngModel"
                type="checkbox"
                id="checkValidTo"
                name="checkValidTo"
                class="custom-control-input"
                [(ngModel)]="checkValidTo"
                (change)="checkValidToChanged()"
              />
              <label class="custom-control-label" for="checkValidTo">
                {{ 'user-self-service.tax.change-fsa.label-valid-to' | transloco }}
              </label>
            </div>
          </div>
        }
        @if (!checkValidTo && dialogMode === 'edit') {
          <div class="col-12 col-sm-6 Xmt-sm-4 mt-2">
            <div
              class="input-group-material"
              [class.input-group-material--error]="fsavalidtoInputVar.invalid && fsavalidtoInputVar.touched"
            >
              <input
                type="text"
                required
                [(ngModel)]="editData[ATTR_NEW_FSA_VALIDTO]"
                name="fsavalidtoyear"
                id="fsavalidtoyear"
                #fsavalidtoInputVar="ngModel"
                [class.empty]="!fsavalidtoInputVar.value"
                pattern="\d{4}"
                formValidatorsYearInputValidator
                [minYear]="editData[ATTR_NEW_FSA_VALIDFROM]"
                (input)="inputValueChanged()"
              />
              <span class="input-group-material-icon-state"></span>
              <label for="fsavalidtoyear" [innerHTML]="'user-self-service.tax.change-fsa.label-valid-to-year' | transloco"> - </label>
              @if (fsavalidtoInputVar.valid || fsavalidtoInputVar.hasError('required')) {
                <div class="input-group-material-message">&nbsp;</div>
              }
              @if (fsavalidtoInputVar.hasError('minYear') || fsavalidtoInputVar.hasError('maxYear')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-fsa.valid-to-error-hint' | transloco }}
                </div>
              }
            </div>
          </div>
        }
        @if (checkValidTo) {
          <div class="col-6 d-none d-sm-block"></div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 d-flex">
            @if (f.valid) {
              <web-design-system-button [isSubmit]="true" type="secondary" size="small" [href]="pdfUrl">
                {{ 'user-self-service.tax.change-fsa.btn-preview' | transloco }}
              </web-design-system-button>
            }
            @if (!f.valid) {
              <web-design-system-button [disabled]="true" type="secondary" size="small">
                {{ 'user-self-service.tax.change-fsa.btn-preview-disabled' | transloco }}
              </web-design-system-button>
            }
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12">
            <div class="custom-control custom-checkbox margin-bottom-15 mt-2">
              <input type="checkbox" id="previewSeen" name="previewSeen" class="custom-control-input" [(ngModel)]="previewSeen" />
              <label
                class="custom-control-label"
                for="previewSeen"
                [innerHTML]="'user-self-service.tax.change-fsa.label-preview-seen' | transloco"
              >
                -
              </label>
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 d-flex flex-column margin-top-15 margin-bottom-15 justify-content-between">
            <span class="mb-3">{{ 'user-self-service.tax.change-fsa.hint-authorization-required' | transloco }}</span>
            <div>
              <web-design-system-button size="small" [disabled]="!f.valid || !previewSeen" [isSubmit]="true">
                {{ 'user-self-service.tax.change-fsa.btn-continue' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        }
      </form>
      @if (dialogMode === 'verify') {
        <div class="row">
          <div class="col-12">
            <p class="mt-3 border-bottom d-inline-block">{{ 'user-self-service.tax.change-fsa.hint-confirm-change' | transloco }}</p>
            <p
              class="mb-1"
              [innerHTML]="
                'user-self-service.tax.change-fsa.confirm.amount'
                  | transloco: { amount: editData[ATTR_NEW_FSA_AMOUT] | currency: 'EUR' : 'symbol' }
              "
            ></p>
            <p
              class="mb-1"
              [innerHTML]="
                'user-self-service.tax.change-fsa.confirm.valid-from-to'
                  | transloco
                    : {
                        fromDate: editData[ATTR_NEW_FSA_VALIDFROM],
                        toDate: !checkValidTo ? '31.12.' + editData[ATTR_NEW_FSA_VALIDTO] : 'auf weiteres',
                      }
              "
            ></p>
          </div>
        </div>
      }
      @if (dialogMode === 'verify') {
        <div class="row mt-3">
          <div class="col-12 d-flex">
            <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
          </div>
        </div>
      }
    </div>
  }
</div>
